import { ACCEPTED_FILES, ACCEPTED_IMAGES, UPLOADS } from '../constants';
import React from 'react';
import { IconCamera, IconDocument, IconLossofUse, IconButton, IconHelp, Popover, BodyText, Heading } from '@lmig/lmds-react';
import { Box } from '@mui/material';

import { red } from '@mui/material/colors';

const uploadsInstance = () => {
const uploads = {
    files: [],
    totalUploadSize: 0,
    noSupplementError: false,
    invalidSupplementError: false,
    invalidPhotosError: false,
    invalidOtherDocumentsError: false,
    minFileSizeError: false,
    maxFileSizeError: false,
    maxTotalFileSizeError: false,
    maxFileCountError: false,
    minFileSizeNames: new Set(),
    maxFileSizeNames: new Set(),
    maxTotalFileSizeNames: new Set(),
    maxFileCountNames: new Set()
  };
  return uploads;
};
 const fileDocStyle = {

  height: '110px',
  width: '160px',
  border: '1px solid #C0BFC0', // 1px border for images
  padding: '37px 64px', // 64px padding for image icon
  background:'rgba(230, 230, 230, 1)'
  };

  
  const categoryListItem = {
  paddingBottom: '8px'
  };

  const imageSrcStyle = {
    top: 'auto',
    left: 'auto',
    height: '120px',
    width: '160px',
     border: '1px solid #C0BFC0'
   
  };
const setUploadedFiles = (event, values, setValues) => {
  const files = event;
  values.uploads.files.push(...files);

  for (const file of files) {
    switch (file.category) {
    case 'estimate':
      validateEstimate(values);
      break;
    case 'photos':
      validatePhotos(values);
      break;
    case 'other':
      validateOtherDocuments(values);
      break;
    default:
      break;
    }
  }

  setValues((prevValues) => ({
    ...prevValues,
    ...values
  }));
};

const setRemovedFiles = (event, values, setValues) => {
  const index = values.uploads.files.findIndex((file) => file.id === event);
  if (index > -1) {
    const fileToRemove = values.uploads.files.filter((file) => file.id === event);
    values.uploads.totalUploadSize -= fileToRemove[0].rawSize;
    values.uploads.files.splice(index, 1);
  }
  validateUploads(values);

  setValues((prevValues) => ({
    ...prevValues,
    ...values
  }));
};

const setMinFileSizeError = (event, values, setValues) => {
  values.uploads.minFileSizeError = true;
  setValues((prevValues) => ({
    ...prevValues,
    ...values
  }));
};

const setMinFileSizeErrorIsCleared = (event, values, setValues) => {
  values.uploads.minFileSizeError = false;
  values.uploads.minFileSizeNames.clear();
  setValues((prevValues) => ({
    ...prevValues,
    ...values
  }));
};

const setMaxFileSizeError = (event, values, setValues) => {
  values.uploads.maxFileSizeError = true;
  setValues((prevValues) => ({
    ...prevValues,
    ...values
  }));
};

const setMaxFileSizeErrorIsCleared = (event, values, setValues) => {
  values.uploads.maxFileSizeError = false;
  values.uploads.maxFileSizeNames.clear();
  setValues((prevValues) => ({
    ...prevValues,
    ...values
  }));
};

const setMaxTotalFileSizeError = (event, values, setValues) => {
  values.uploads.maxTotalFileSizeError = true;
  setValues((prevValues) => ({
    ...prevValues,
    ...values
  }));
};

const setMaxTotalFileSizeErrorIsCleared = (event, values, setValues) => {
  values.uploads.maxTotalFileSizeError = false;
  values.uploads.maxTotalFileSizeNames.clear();
  setValues((prevValues) => ({
    ...prevValues,
    ...values
  }));
};

const setMaxFileCountError = (event, values, setValues) => {
  values.uploads.maxFileCountError = true;
  setValues((prevValues) => ({
    ...prevValues,
    ...values
  }));
};
const setInvalidFile = (event, values, setValues) => {
  values.uploads.invalidSupplementsError = true;
  setValues((prevValues) => ({
    ...prevValues,
    ...values
  }));
};
 const clearInvalidFile = (event, values, setValues) => {
  values.uploads.invalidSupplementsError = false;
  setValues((prevValues) => ({
    ...prevValues,
    ...values
  }));
};

const setMaxFileCountErrorIsCleared = (event, values, setValues) => {
  values.uploads.maxFileCountError = false;
  values.uploads.maxFileCountNames.clear();
  setValues((prevValues) => ({
    ...prevValues,
    ...values
  }));
};

const setThumbnailSubtitle = (file) => !file.src || !file.src.includes(';base64') ? (
  
  <b style={{ color: red[500] }}> Invalid {UPLOADS[file.category.toUpperCase()].FILE_LABEL} File </b>
) : (
  file.size
);

const filterFilesByCategory = (uploads, category) => {
  const files = uploads.files.filter(
    (file) => file.category === category
  );
  const filesWithNoSrc = uploads.files.filter(
    (file) =>
      (!file.src || !file.src.includes(';base64')) &&
          file.category === category
  );
  return { files, filesWithNoSrc };
};

const validateEstimate = (values) => {
  const estimate = filterFilesByCategory(values.uploads, 'estimate');
  values.uploads.invalidSupplementError =  estimate.filesWithNoSrc.length > 0;

  
  return true;
};

const validatePhotos = (values) => {
  const photos = filterFilesByCategory(values.uploads, 'photos');
  values.uploads.invalidPhotosError = photos.filesWithNoSrc.length > 0;

  const invalidPhotos = values.uploads.invalidPhotosError;
  return !invalidPhotos;
};

const validateOtherDocuments = (values) => {
  const otherDocuments = filterFilesByCategory(values.uploads, 'other');
  values.uploads.invalidOtherDocumentsError = otherDocuments.filesWithNoSrc.length > 0;

  const invalidOtherDocuments = values.uploads.invalidOtherDocumentsError;
  return !invalidOtherDocuments;
};

const validateUploads = (values) => {
  const validEstimate = validateEstimate(values); 
  return (validEstimate);
};

const setPopoverText = (category, popoverText) => {
  switch (category) {
  case UPLOADS.PHOTOS.CATEGORY:
    return (
      <Box>
        <p>{popoverText.TEXT_START}</p>
        <p>{popoverText.TEXT_MIDDLE}</p>
        <p>{popoverText.TEXT_END}</p>
      </Box>
    );
  case UPLOADS.OTHER.CATEGORY:
    return (
      <Box>
        <p>{popoverText.TEXT_START}</p>
        <li>{popoverText.LIST_ITEM_A}</li>
        <li>{popoverText.LIST_ITEM_B}</li>
        <li>{popoverText.LIST_ITEM_C}</li>
        <li>{popoverText.LIST_ITEM_D}</li>
        <li>{popoverText.LIST_ITEM_E}</li>
      </Box>
    );
  default:
    break;
  }
};
const setPhotoText = (text) => {
  if (
    !text ||
    typeof text.TEXT_START === 'undefined' ||
    typeof text.LIST_ITEM_A === 'undefined' ||
    typeof text.LIST_ITEM_B === 'undefined' ||
    typeof text.LIST_ITEM_C === 'undefined'
  ) {
    return null;
  }
  const [firstWord, ...rest] = text.LIST_ITEM_B.split(' ');
  const [secondWord, ...rest1] = text.LIST_ITEM_C.split(' ');

  return (
    <Box style={{ marginTop: '96px' }}>
      <Heading type='h3-light' >
        {text.TEXT_START}
      </Heading>

     <p style={{ maxWidth: '730px', lineHeight: '25.6px',fontFamily: '"Roboto", Arial, sans-serif' }}>   <span>
  After you upload your files, please specify if the file is a{' '}
  <b>photo</b> <b>or</b> <b>a</b> <b>document.</b>
</span> {text.LIST_ITEM_D}</p>
       <p style={{  lineHeight: '25.6px', fontFamily:'"Roboto" , Arial, sans-serif' }}><b>{firstWord}</b> {rest.join(' ')}</p>
        <p style={{  lineHeight: '25.6px',fontFamily:'"Roboto" , Arial, sans-serif' }}><b>{secondWord}</b> {rest1.join(' ')}</p>
     
    </Box>
  );
};
const setCategoryText = (category, text) => {
  switch (category) {
  case UPLOADS.ESTIMATE.CATEGORY:
    return (
      <Box>
        <p><b>{text.TEXT_START}</b></p>
        <ul>
        <li style={categoryListItem}>{text.LIST_ITEM_A}
        <Popover
          direction= 'above'
          trigger={
            <IconButton background='transparent'>
              <IconHelp color='teal' size='16' />
            </IconButton>
          }
          variant='inlineIcon'
        >
          <BodyText>
                <p>
                  We accept files in PDF, Word (like <b>.doc, .docx, and .rtf</b>), Excel (like <b>.xls and .xlsx</b>)
                </p>
                <p>
                  We prefer PDF files whenever possible.
                </p>
              </BodyText>
        </Popover>
        </li>
        <li>{text.LIST_ITEM_B}</li>
        </ul>
      </Box>
    );
    case UPLOADS.PHOTOS.CATEGORY:
    return (
      <Box>
        <p><b>{text.TEXT_START}</b></p>
        <ul>
          <li style={categoryListItem}>{text.LIST_ITEM_A}
            <Popover
              direction='above'
              trigger={
                <IconButton background='transparent'>
                  <IconHelp color='teal' size='16' />
                </IconButton>
              }
              variant='inlineIcon'
            >
              <BodyText>
            <p>
            We accept files in PDF, Word (like <b>.doc, .docx, and .rtf</b>), Excel (like <b>.xls and .xlsx</b>),
            and common image formats (such as <b>.jpg, .png, and .tiff</b>).
            </p>
           
          </BodyText>              
            </Popover>
          </li>
          <li style={categoryListItem}>{text.LIST_ITEM_B}</li>
          <li>{text.LIST_ITEM_C}</li>
        </ul>
      </Box>
    );
    

        
    
    default:
    break;
  }
};

const setAcceptedFiles = (category) => {
  switch (category) {
  case UPLOADS.PHOTOS.CATEGORY:
    return { ...ACCEPTED_FILES, ...ACCEPTED_IMAGES };
  case UPLOADS.OTHER.CATEGORY:
    return { ...ACCEPTED_FILES, ...ACCEPTED_IMAGES };
  default:
    return ACCEPTED_FILES;
  }
};

const setDropzoneIcon = (category) => {
  switch (category) {
  case UPLOADS.ESTIMATE.CATEGORY:
    return <IconLossofUse size="64" style={{ marginTop: '40px' }}/>;
  case UPLOADS.PHOTOS.CATEGORY:
    return <IconCamera size="64" style={{ marginTop: '40px' }}/>;
  case UPLOADS.OTHER.CATEGORY:
    return <IconDocument size="64" style={{ marginTop: '40px' }}/>;
  default:
    break;
  }
};

const setDropzoneText = (category) => {
  switch (category) {
  case UPLOADS.ESTIMATE.CATEGORY:
    return (
        <p>{UPLOADS.ESTIMATE.DROPZONE}</p>
    );
  case UPLOADS.PHOTOS.CATEGORY:
    return (
      <p>{UPLOADS.PHOTOS.DROPZONE}</p>
    );
  case UPLOADS.OTHER.CATEGORY:
    return (
      <p>{UPLOADS.OTHER.DROPZONE}</p>
    );
  default:
    break;
  }
};

const imageContent = (image) => {
  const type =
        image.src && image.src.includes(';base64')
          ? image.src.split('/')[0].split(':')[1]
          : 'Invalid file';
 
    if (type !== 'image') {
    return <div style={fileDocStyle}><IconDocument src="16"  /></div>;
  }
  return <img style={imageSrcStyle} alt='X' src={image.src} />;
};

export {
  uploadsInstance,
  imageContent,
  setInvalidFile,
  clearInvalidFile,
  setAcceptedFiles,
  setDropzoneIcon,
  setDropzoneText,
  setPopoverText,
  setCategoryText,
  setPhotoText,
  setUploadedFiles,
  setRemovedFiles,
  setThumbnailSubtitle,
  setMinFileSizeError,
  setMinFileSizeErrorIsCleared,
  setMaxFileSizeError,
  setMaxFileSizeErrorIsCleared,
  setMaxTotalFileSizeError,
  setMaxTotalFileSizeErrorIsCleared,
  setMaxFileCountError,
  setMaxFileCountErrorIsCleared,
  validateUploads
};
